export enum AuditoryReactions {
    Single,
    Double
}